var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgIllustrationSuccess = function SvgIllustrationSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 400 324"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-success_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.754,
    cy: 141.348,
    fill: "url(#illustration-success_svg__b)",
    rx: 10.5,
    ry: 10.512
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.807,
    cy: 10.512,
    fill: "url(#illustration-success_svg__c)",
    rx: 10.5,
    ry: 10.512
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-success_svg__d)",
    strokeWidth: 2.628,
    d: "M341.382 70.71c0 5.082-4.114 9.198-9.186 9.198s-9.186-4.117-9.186-9.198c0-5.082 4.114-9.199 9.186-9.199s9.186 4.117 9.186 9.199Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-success_svg__e)",
    strokeWidth: 2.628,
    d: "M20.69 201.796c0 5.081-4.114 9.198-9.186 9.198s-9.186-4.117-9.186-9.198c0-5.082 4.114-9.199 9.186-9.199s9.186 4.117 9.186 9.199Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.75,
    cy: 264.872,
    fill: "url(#illustration-success_svg__f)",
    rx: 5.25,
    ry: 5.256
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.378,
    cy: 20.454,
    fill: "url(#illustration-success_svg__g)",
    rx: 5.25,
    ry: 5.256
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.754,
    cy: 241.217,
    fill: "url(#illustration-success_svg__h)",
    rx: 5.25,
    ry: 5.256
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 346.811,
    cy: 172.813,
    fill: "url(#illustration-success_svg__i)",
    rx: 3.864,
    ry: 3.868
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.127,
    cy: 65.132,
    fill: "url(#illustration-success_svg__j)",
    rx: 5.25,
    ry: 5.256
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-success_svg__k)",
    strokeWidth: 2.628,
    d: "M346.187 136.092a3.939 3.939 0 0 1-3.936 3.942 3.938 3.938 0 0 1-3.936-3.942 3.938 3.938 0 0 1 3.936-3.942 3.939 3.939 0 0 1 3.936 3.942Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-success_svg__l)",
    fillRule: "evenodd",
    d: "M380.17 103.087a1.141 1.141 0 1 0-2.282-.007l-.009 2.973-2.966-.009a1.142 1.142 0 1 0-.007 2.285l2.966.009-.009 2.972a1.141 1.141 0 1 0 2.282.007l.009-2.972 2.967.009a1.142 1.142 0 1 0 .007-2.285l-2.967-.009z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-success_svg__m)",
    fillRule: "evenodd",
    d: "M376.397 164.263a1.141 1.141 0 1 0-2.283-.007l-.009 2.973-2.966-.009a1.142 1.142 0 1 0-.007 2.285l2.966.009-.009 2.972a1.142 1.142 0 0 0 2.283.007l.009-2.972 2.966.009a1.142 1.142 0 1 0 .007-2.285l-2.966-.009z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-success_svg__n)",
    fillRule: "evenodd",
    d: "M86.308 57.097a1.311 1.311 0 0 0-1.332-1.293 1.315 1.315 0 0 0-1.295 1.333l.1 7.208-6.535.098a1.315 1.315 0 0 0-1.295 1.333c.01.725.606 1.304 1.331 1.293l6.535-.098.081 5.923c.01.725.606 1.305 1.331 1.294a1.315 1.315 0 0 0 1.296-1.333l-.082-5.923 6.597-.099a1.315 1.315 0 0 0 1.295-1.333 1.311 1.311 0 0 0-1.33-1.293l-6.598.099z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-success_svg__o)",
    fillRule: "evenodd",
    d: "M11.356 127.047a1.311 1.311 0 0 0-1.332-1.294 1.316 1.316 0 0 0-1.295 1.333l.1 7.208-6.535.098a1.312 1.312 0 1 0 .036 2.627l6.535-.098.081 5.922c.01.726.606 1.305 1.332 1.294a1.316 1.316 0 0 0 1.295-1.333l-.082-5.923 6.597-.098a1.316 1.316 0 0 0 1.295-1.333 1.312 1.312 0 0 0-1.33-1.294l-6.598.099z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-success_svg__p)",
    fillRule: "evenodd",
    d: "M367.179 220.039a1.312 1.312 0 0 0-1.331-1.294 1.316 1.316 0 0 0-1.295 1.333l.099 7.211-6.534.098a1.314 1.314 0 0 0 .036 2.626l6.534-.098.082 5.921c.01.725.606 1.304 1.331 1.293a1.315 1.315 0 0 0 1.295-1.333l-.081-5.92 6.597-.099a1.316 1.316 0 0 0 1.295-1.333 1.311 1.311 0 0 0-1.331-1.293l-6.597.098z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-success_svg__q)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.286,
    cy: 305.999,
    fill: "#E9E7F6",
    rx: 82.286,
    ry: 8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-success_svg__r)",
    d: "M140.794 169.728c-5.794-5.055-14.588-4.455-19.643 1.339-5.054 5.794-4.454 14.588 1.34 19.642l37.815 32.988c11.588 10.108 29.176 8.909 39.284-2.679z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-success_svg__s)",
    fillRule: "evenodd",
    d: "M286.483 120.777c-11.633-10.056-29.216-8.777-39.272 2.856l-69.974 80.952c-10.144 11.052-14.9 14.943-25.793 11.676l9.281 8.12.34-.404c11.634 9.74 28.973 8.375 38.932-3.146z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__b",
    x1: 58.469,
    x2: -17.333,
    y1: 157.792,
    y2: 137.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__c",
    x1: 229.522,
    x2: 153.72,
    y1: 26.955,
    y2: 6.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__d",
    x1: 331.911,
    x2: 256.11,
    y1: 87.153,
    y2: 67.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__e",
    x1: 11.219,
    x2: -64.582,
    y1: 218.239,
    y2: 198.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__f",
    x1: 394.608,
    x2: 356.707,
    y1: 273.094,
    y2: 263.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__g",
    x1: 145.235,
    x2: 107.335,
    y1: 28.676,
    y2: 18.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__h",
    x1: 58.611,
    x2: 20.71,
    y1: 249.439,
    y2: 239.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__i",
    x1: 346.706,
    x2: 318.812,
    y1: 178.864,
    y2: 171.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__j",
    x1: 244.984,
    x2: 207.083,
    y1: 73.354,
    y2: 63.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__k",
    x1: 342.108,
    x2: 304.208,
    y1: 144.314,
    y2: 134.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__l",
    x1: 378.874,
    x2: 340.974,
    y1: 115.42,
    y2: 105.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__m",
    x1: 375.101,
    x2: 337.2,
    y1: 176.596,
    y2: 166.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__n",
    x1: 77.019,
    x2: 50.363,
    y1: 73.035,
    y2: 27.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__o",
    x1: 2.067,
    x2: -24.589,
    y1: 142.984,
    y2: 96.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__p",
    x1: 357.89,
    x2: 331.231,
    y1: 235.978,
    y2: 189.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__r",
    x1: 108.854,
    x2: 103.275,
    y1: 165.662,
    y2: 227.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-success_svg__s",
    x1: 218.963,
    x2: 218.963,
    y1: 113.998,
    y2: 230.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#9FBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-success_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h400v324H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-success_svg__q",
    width: 181.919,
    height: 33.348,
    x: 107.326,
    y: 289.325,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_3689_80149",
    stdDeviation: 4.337
  })))));
};
var Memo = /*#__PURE__*/memo(SvgIllustrationSuccess);
export default Memo;